export default "__VITE_ASSET__AuYC71Tv__"